import { render, staticRenderFns } from "./MarinaTwgVaccinationSchedules.vue?vue&type=template&id=8d33513e&scoped=true"
import script from "./MarinaTwgVaccinationSchedules.vue?vue&type=script&lang=js"
export * from "./MarinaTwgVaccinationSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d33513e",
  null
  
)

export default component.exports